import { get, post } from './client';
import { API_ENDPOINTS } from '../config/api';

export interface EventLink {
  title: string;
  url: string;
}

export interface EventFee {
  name?: string;
  amount?: number;
}

export interface EventData {
  id: number;
  name: string;
  start: string;
  end: string;
  app_enable?: string;
  start_promotion?: string;
  links?: EventLink[];
  fee?: EventFee;
}

export interface EventType {
  event?: EventData;
}

interface EventListResponse {
  event_types?: EventType[];
  error?: {
    message?: string;
  } | null;
}

export interface Account {
  id: string;
  cid: string;
  qr_code: string;
  vid?: string;
}

interface AccountResponse {
  account?: Account;
  error?: {
    message?: string;
  } | null;
}

export interface Purse {
  purse_num: number;
  value: string;
}

interface ValueResponse {
  purses: Purse[];
  error?: {
    message?: string;
  };
}

export interface HistoryItem {
  id: number;
  reversed: boolean;
  device: string;
  datetime: string;
  change?: ChangeResponse;
}

interface ChangeResponse {
  items: ChangeItemResponse[];
  p1_delta?: {
    balance: number;
    delta: number;
  }
}

interface ChangeItemResponse {
  id: number;
  name: string;
}

interface HistoryResponse {
  history: HistoryItem[];
  first_id?: number | null;
  last_id?: number | null;
  error?: {
    message?: string;
  };
}

export async function getEventList() {
  return get<EventListResponse>(API_ENDPOINTS.EVENT_LIST);
}

export async function getAccount(loginKey: string, event: number) {
  return post<AccountResponse>(API_ENDPOINTS.GET_ACCOUNT, {
    login_key: loginKey,
    event,
  });
}

export async function getValue(loginKey: string, cid: string) {
  return post<ValueResponse>(API_ENDPOINTS.GET_VALUE, {
    login_key: loginKey,
    cid,
  });
}

interface GetHistoryParams {
  loginKey: string;
  cid: string;
  beforeId?: number;
  afterId?: number;
}

export async function getHistory({ loginKey, cid, beforeId, afterId }: GetHistoryParams) {
  return post<HistoryResponse>(API_ENDPOINTS.GET_HISTORY, {
    login_key: loginKey,
    cid,
    mode: 'v2',
    before_id: beforeId,
    after_id: afterId,
  });
}

export default {
  getEventList,
  getAccount,
  getValue,
  getHistory,
};
